import { routes as printRoutes } from "./prints/routes";
export const routes = (prefix = `med-f`) => [
    {
        path: `/${prefix}/:patientID`,
        name: `${prefix}.med-file.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
        },
    },
    {
        path: `/${prefix}/:patientID/:visitNo`,
        name: `${prefix}.visit.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `medical-file.create`,
                PageDescription: "Patient Medical File",
            },
        },
    },
    ...printRoutes(),
];
